import { SpecialOfferRowActions } from 'modules/sales-offer/special-offer/components/SpecialOfferRowActions';
import { CellAlign, CellType, EditLink, HeadCell } from '@dfl/mui-admin-layout';
import { ISpecialOffer } from 'modules/sales-offer/special-offer/interfaces';
import { SPECIAL_OFFER_PERMISSIONS } from 'modules/sales-offer/special-offer/constants/special-offer.permissions';
import { AvatarNameCell } from 'modules/common/components/AvatarNameCell';
import { IImageMedia } from 'modules/common/interfaces';
import { ReactLink } from '@dfl/react-security';
import { bannerDesktopColumn, bannerMobileColumn } from 'modules/cms/banners/constants';
import { renderOfferStatus } from 'modules/sales-offer/offer/components/OfferStatus/OfferStatus';
import { SpecialOfferRegionCell } from '../components/SpecialOfferRegionCell';
import { IconButton } from '@dfl/mui-react-common';
import { Link } from '@mui/icons-material';

export const specialOfferImageColumn: HeadCell<ISpecialOffer> = {
  field: 'image',
  headerName: 'category:fields.image',
  disablePadding: false,
  sortable: false,
  renderCell: (value: IImageMedia) => <AvatarNameCell hideLink image={value} variant={'rounded'} />,
};

export const specialOfferNameColumn: HeadCell<ISpecialOffer> = {
  field: 'name',
  headerName: 'specialOffer:fields.name',
  disablePadding: false,
  renderCell: (name: string, data?: ISpecialOffer) => (<EditLink entityId={data?._id as string}>{name}</EditLink>),
};

export const startDateColumn: HeadCell<any> = {
  field: 'startDate',
  type: CellType.DATE,
  headerName: 'banner:fields.startDate',
  format: 'dd/MM/yyyy | hh:mm aa',
};

export const endDateColumn: HeadCell<any> = {
  field: 'endDate',
  type: CellType.DATE,
  headerName: 'banner:fields.endDate',
  format: 'dd/MM/yyyy | hh:mm aa',
};

const buildStoreUrl = (value: string): string => {
  if (!value) return '';
  if (/^https?:\/\//.test(value)) return value;
  if (value.startsWith('/')) return `https://${process.env.REACT_APP_DOMAIN ?? ''}${value}`;
  return `https://${value}`;
};

export const specialOfferLinkColumn: HeadCell<ISpecialOffer> = {
  field: 'link',
  headerName: 'specialOffer:fields.linkUrl.label',
  disablePadding: true,
  align: CellAlign.CENTER,
  headerAlign: CellAlign.CENTER,
  renderCell: (value: string) => {
    return (
      <ReactLink to={buildStoreUrl(value)} target='_blank'>
        <IconButton tooltip={value}>
          <Link color='primary' />
        </IconButton>
      </ReactLink>
    )
  }
};

export const specialOfferRegionColumn: HeadCell<ISpecialOffer> = {
  field: 'storeRegions',
  headerName: 'specialOffer:fields.region.title',
  sortable: false,
  component: SpecialOfferRegionCell,
  width: 320,
  cellClassName: 'min-w-[320px]',
};

export const specialOfferActionsColumn: HeadCell<ISpecialOffer> = {
  field: 'actions',
  sortable: false,
  width: 100,
  permissions: SPECIAL_OFFER_PERMISSIONS.SPECIAL_OFFER_WRITE,
  headerName: 'common:actions',
  disablePadding: true,
  component: SpecialOfferRowActions,
};

export const specialOfferStatusColumn: HeadCell<ISpecialOffer> = {
  field: 'status',
  align: CellAlign.CENTER,
  headerAlign: CellAlign.CENTER,
  headerName: 'offerOrder:status.title',
  renderCell: (_, data) => renderOfferStatus(data?.startDate, data?.endDate),
};

export const specialOfferColumns: Array<HeadCell<any>> = [
  bannerDesktopColumn,
  bannerMobileColumn,
  specialOfferNameColumn,
  specialOfferRegionColumn,
  specialOfferLinkColumn,
  specialOfferStatusColumn,
  startDateColumn,
  endDateColumn,
  specialOfferActionsColumn
];
